import { render, staticRenderFns } from "./GoalListMandalaSection.vue?vue&type=template&id=f7de2fac&scoped=true&"
import script from "./GoalListMandalaSection.vue?vue&type=script&lang=js&"
export * from "./GoalListMandalaSection.vue?vue&type=script&lang=js&"
import style0 from "./GoalListMandalaSection.vue?vue&type=style&index=0&id=f7de2fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7de2fac",
  null
  
)

export default component.exports